export default [
  {
    path: '/scoreReview',
    name: 'scoreReview',
    meta: {
      title: '领积分审核'
    },
    component: () =>
        import(
          /* webpackChunkName: "scoreReview" */ '@/views/scoreReview/index.vue'
        )
  },
  {
    path: '/scoreReview/info',
    name: 'scoreReviewInfo',
    meta: {
      title: '领积分审核详情'
    },
    component: () =>
        import(
          /* webpackChunkName: "scoreReviewInfo" */ '@/views/scoreReview/info.vue'
        )
  },
  {
    path: '/recoveryValuation',
    name: 'recoveryValuation',
    meta: {
      title: '回收估价'
    },
    component: () =>
        import(
          /* webpackChunkName: "recoveryValuation" */ '@/views/recoveryValuation/index.vue'
        )
  },
  {
    path: '/recoveryValuation/info',
    name: 'recoveryValuationInfo',
    meta: {
      title: '回收估价详情'
    },
    component: () =>
        import(
          /* webpackChunkName: "recoveryValuationInfo" */ '@/views/recoveryValuation/info.vue'
        )
  }
]
